{
  "deselectedItem": "{item} не е избран.",
  "longPressToSelect": "Натиснете и задръжте за да влезете в избирателен режим.",
  "select": "Изберете",
  "selectedAll": "Всички елементи са избрани.",
  "selectedCount": "{count, plural, =0 {Няма избрани елементи} one {# избран елемент} other {# избрани елементи}}.",
  "selectedItem": "{item} избран."
}
